import { ProfitAndLossVoucherRowsData } from "@/types/profit-and-loss-voucher-rows-api";
import { getBalanceSheetVoucherRows } from "@/services/balance-sheet-voucher-rows-api";
import { callApiWithChecks } from "./use-template";
import { FULL_YEAR_MONTHS } from "@/lib/time_utils";

export function useBalanceSheetVoucherRows(
    clientId: string,
    connectionId: string,
    months: number[],
    year: number,
    enabled: boolean
) {
    const monthsKey = months.length ? months.join(',') : FULL_YEAR_MONTHS.join(',');
    return callApiWithChecks<ProfitAndLossVoucherRowsData>(
        () => getBalanceSheetVoucherRows(clientId, [connectionId], months, year),
        [clientId, connectionId, monthsKey, year],
        enabled,
        { title: 'Error', description: 'Failed to load profit & loss (monthly) report' }
    );
}